import { render, staticRenderFns } from "./AuthoriseOpgOld.vue?vue&type=template&id=eec5bc76"
import script from "./AuthoriseOpgOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseOpgOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eec5bc76')) {
      api.createRecord('eec5bc76', component.options)
    } else {
      api.reload('eec5bc76', component.options)
    }
    module.hot.accept("./AuthoriseOpgOld.vue?vue&type=template&id=eec5bc76", function () {
      api.rerender('eec5bc76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseOpgOld.vue"
export default component.exports